"use client";

import { Check } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function WhyChooseAAEaglePlumbing() {
  const {
    ref: sectionRef,
    isVisible: sectionVisible
  } = useRevealOnScroll({
    threshold: 0.2,
    once: true
  });
  const benefits = [{
    id: 1,
    text: "Specialized Water Pump Expertise"
  }, {
    id: 2,
    text: "Fast Emergency Pump Repairs"
  }, {
    id: 3,
    text: "Certified Pump Technicians"
  }, {
    id: 4,
    text: "All Pump Types & Brands Serviced"
  }, {
    id: 5,
    text: "Reliable Installation & Maintenance"
  }];
  return <section ref={sectionRef}
  // MEJORA 1: Cambiamos text-foreground-dark por text-white/90 a nivel de la sección
  className="bg-dark-background text-white/90 py-16 md:py-24">
      <div className="container mx-auto px-6 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          
          {/* Columna de Texto */}
          <div className="space-y-8">
            <h2
          // MEJORA 2: Reemplazamos text-foreground por text-white e incluimos un drop-shadow-sm
          className={`font-display text-3xl md:text-4xl font-bold text-white drop-shadow-sm transition-all duration-[350ms] ease-[var(--ease-smooth)] ${sectionVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
              Why Choose AA Eagle Plumbing for Water Pumps
            </h2>

            <ul className="space-y-4">
              {benefits.map((benefit, i) => <li key={benefit.id} data-index={i} className={`flex items-start gap-3 transition-all duration-[350ms] ease-[var(--ease-smooth)] ${sectionVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
              transitionDelay: sectionVisible ? `${(i + 1) * 100}ms` : "0ms"
            }}>
                  <div className="flex-shrink-0 w-6 h-6 rounded-full bg-secondary flex items-center justify-center mt-0.5">
                    {/* MEJORA 3: Aseguramos que el ícono (palomita) también contraste bien con su fondo (bg-secondary) */}
                    <Check className="w-4 h-4 text-white" />
                  </div>
                  {/* MEJORA 4: Texto de la lista forzado a blanco con opacidad alta (white/90) y sombra suave */}
                  <span className="text-white/90 drop-shadow-sm text-base md:text-lg">
                    {benefit.text}
                  </span>
                </li>)}
            </ul>
          </div>

          {/* Columna de Imagen */}
          <div className={`relative overflow-hidden rounded-xl shadow-medium transition-all duration-[350ms] ease-[var(--ease-smooth)] ${sectionVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
          transitionDelay: sectionVisible ? "300ms" : "0ms"
        }}>
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1521681/img/completed_plumbing_project_installation.png" alt="Completed water pump installation showcasing AA Eagle Plumbing's quality workmanship" className="w-full h-auto object-cover aspect-[4/3]" />
          </div>
        </div>
      </div>
    </section>;
}